import script from "./WeekListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./WeekListItem.vue?vue&type=script&setup=true&lang=js"

import "./WeekListItem.vue?vue&type=style&index=0&id=7b3a71be&lang=css"

const __exports__ = script;

export default __exports__